import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardStatus extends BaseModelAPI {
	static entity = 'controlcardstatus';
	static entityName = 'controlcardstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}